<div class="monitor-layout">
  <div class="monitor-container">

    <!-- Header Unificado -->
    <div class="unified-header">
      <div class="header-left">
        <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">
          <mat-icon class="title-icon">inventory</mat-icon>
          Monitor de Órdenes de Surtimiento
        </h1>
      </div>
      <!-- Espacio reservado para widgets futuros -->
      <div></div>
    </div>

    <!-- Spinner de carga principal (solo API) -->
    @if (apiLoadingSignal()) {
    <div class="spinner-container">
      <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    </div>
    } @else {

    <!-- Panel de Filtros Colapsable Compacto -->
    <mat-expansion-panel class="filters-panel-compact" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div style="display: flex; align-items: center; gap: 6px;">
            <mat-icon>filter_list</mat-icon>
            <span>Filtros</span>
            <!-- Spinner local alineado inmediatamente después de "Filtros" -->
            @if (isFilteringSignal()) {
            <mat-progress-spinner mode="indeterminate" diameter="20" class="filter-spinner"
              style="margin-left: 2px;"></mat-progress-spinner>
            }
          </div>
        </mat-panel-title>
        <mat-panel-description>
          <span>{{ totalOrdenesFiltradasSignal() }} resultados</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <form [formGroup]="filtroForm" class="filtros-form-compact">
        <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
          <mat-label>Buscar</mat-label>
          <input matInput formControlName="textoGeneral" [readonly]="isLoadingSignal()" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
          <mat-label>Cliente</mat-label>
          <input type="text" matInput formControlName="cliente" [matAutocomplete]="autoCliente"
            [readonly]="isLoadingSignal()" />
          <mat-autocomplete #autoCliente="matAutocomplete">
            @for (option of filteredClientes$ | async; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
          <mat-label>RFC</mat-label>
          <input type="text" matInput formControlName="rfc" [matAutocomplete]="autoRfc"
            [readonly]="isLoadingSignal()" />
          <mat-autocomplete #autoRfc="matAutocomplete">
            @for (option of filteredRfcs$ | async; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="dense-field status-field" subscriptSizing="dynamic">
          <mat-label>Estatus Factura</mat-label>
          <mat-select formControlName="estatus" [disabled]="isLoadingSignal()">
            <mat-option value="">Todos</mat-option>
            @for (est of estatusDisponibles(); track est) {
            <mat-option [value]="est">{{ est }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="filter-actions">
          <button mat-icon-button color="primary" (click)="limpiarFiltros()" type="button" matTooltip="Limpiar Filtros"
            [disabled]="isLoadingSignal()">
            <mat-icon>filter_alt_off</mat-icon>
          </button>
          <button mat-icon-button color="accent" (click)="forzarRefrescoCompleto()" type="button" matTooltip="Refrescar"
            [disabled]="isLoadingSignal()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Controles Superiores con Paginador -->
    <div class="controles-superiores">
      <span class="spacer"></span>

      <mat-paginator [length]="totalOrdenesFiltradasSignal()" [pageSize]="pageEventSignal().pageSize"
        [pageIndex]="pageEventSignal().pageIndex" [pageSizeOptions]="[20, 40, 60, 80]"
        aria-label="Seleccionar página de órdenes" (page)="pageEventSignal.set($event)" [disabled]="isLoadingSignal()"
        showFirstLastButtons></mat-paginator>
    </div>

    <!-- Lista de Órdenes -->
    @if (filteredOrdersSignal().length > 0) {
    <mat-accordion [multi]="false" class="facturas-accordion">
      @for (order of ordersPaginadosSignal(); track order.id) {
      <mat-expansion-panel [disabled]="isLoadingSignal()">
        <mat-expansion-panel-header>
          <mat-panel-title class="panel-title-container">
            <div class="factura-info-group">
              <div class="info-item">
                <span class="info-label">Folio Orden:</span>
                <span class="info-value folio">{{ order.folioOrden }}</span>
                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="order.folioOrden"
                  (click)="$event.stopPropagation(); onCopyToClipboard(order.folioOrden)"
                  matTooltip="Copiar Folio Orden">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>

              <div class="info-item">
                <span class="info-label">Remisión:</span>
                <span class="info-value">{{ order.remision.folio }}</span>
              </div>
            </div>

            <div class="factura-info-group">
              <div class="info-item">
                <span class="info-label">Cliente RFC:</span>
                <span class="info-value rfc">{{ order.clienteRFC }}</span>
                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="order.clienteRFC"
                  (click)="$event.stopPropagation(); onCopyToClipboard(order.clienteRFC)" matTooltip="Copiar RFC">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>

              @if (order.factura?.receptorNombre) {
              <div class="info-item">
                <span class="info-label">Nombre:</span>
                <span class="info-value cliente" [matTooltip]="order.factura!.receptorNombre">
                  {{ order.factura!.receptorNombre }}
                </span>
              </div>
              }
            </div>

            <div class="factura-info-group align-right">
              <div class="info-item">
                <span class="info-label">Factura:</span>
                <span class="info-value">{{ order.folioFactura || 'Sin Registrar' }}</span>
              </div>
            </div>

            <div class="factura-info-group status-group">
              <span class="factura-info estatus status-rem-{{ order.remision.estatus }}">
                Rem: {{ order.remision.estatus }}
              </span>
              @if (order.factura) {
              <span class="factura-info estatus status-{{ order.factura.estatus.split(' ').join('-') }}"
                [style.background]="getStatusColor(order.factura.estatus)">
                Fac: {{ order.factura.estatus }}
              </span>
              } @else {
              <span class="factura-info estatus status-Sin-Factura" [style.background]="getStatusColor('Sin Factura')">
                Sin Factura
              </span>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="factura-detalle">
          <div class="stepper-container">
            <!-- Grupo: Remisión -->
            <div class="stepper-group">
              <div class="group-title rem-title">Remisión</div>
              <div class="steps-wrapper">
                <div class="step" matTooltip="La remisión fue aprobada y está lista para surtimiento.">
                  <mat-icon
                    [ngClass]="{'active': order.remision.estatus === 'Aprobada' || order.remision.estatus === 'Validada'}">check_circle</mat-icon>
                  <span>Aprobada</span>
                </div>
                <div class="step"
                  matTooltip="La documentación de entrega fue recibida y validada por el sistema externo (SIMACS).">
                  <mat-icon [ngClass]="{'active': order.remision.estatus === 'Validada'}">
                    check_circle
                  </mat-icon>
                  <span>Validada</span>
                </div>
              </div>
            </div>

            <!-- Grupo: Factura (pasos derivados del catálogo de estatus) -->
            <div class="stepper-group">
              <div class="group-title fac-title">Factura</div>
              <div class="steps-wrapper">
                @for (step of facturaStepperStepsSignal(); track step.group; let i = $index) {
                <div class="step"
                  [matTooltip]="order.factura ? (step.label + '. Estatus del grupo: ' + step.statuses.join(', ') + '. Fecha: ' + getHistoryDateForStatus(order.factura, step.statuses[0])) : step.label">
                  <mat-icon [ngClass]="{'active': isStepperStepActive(order.factura, i)}">{{ getStepIcon(i) }}</mat-icon>
                  <span>{{ step.label }}</span>
                </div>
                }
              </div>
            </div>
          </div>

          <mat-progress-bar mode="determinate" [value]="calculateProgress(order)"
            class="stepper-progress"></mat-progress-bar>

          <mat-action-row>
            <button mat-stroked-button color="primary" (click)="openAddDocsDialog(order)"
              [disabled]="isLoadingSignal()">
              <mat-icon>attach_file</mat-icon>
              Adjuntar Documentos
            </button>
          </mat-action-row>
        </div>
      </mat-expansion-panel>
      }
    </mat-accordion>
    } @else if (!isLoadingSignal() && totalOrdenesFiltradasSignal() === 0) {
    <div class="no-facturas">
      <mat-icon>inbox</mat-icon>
      <p>No se encontraron órdenes de surtimiento con los filtros aplicados o no hay órdenes disponibles.</p>
    </div>
    }

    <!-- Paginador Inferior -->
    @if (!isLoadingSignal() && totalOrdenesFiltradasSignal() > pageEventSignal().pageSize) {
    <div class="bottom-paginator">
      <mat-paginator [length]="totalOrdenesFiltradasSignal()" [pageSize]="pageEventSignal().pageSize"
        [pageIndex]="pageEventSignal().pageIndex" [pageSizeOptions]="[20, 40, 60, 80]"
        aria-label="Seleccionar página de órdenes" (page)="pageEventSignal.set($event)" [disabled]="isLoadingSignal()"
        showFirstLastButtons></mat-paginator>
    </div>
    }
    }
  </div>
</div>